module.exports = __webpack_public_path__ + "img/aura.65e73ee.png";